module.exports = __webpack_public_path__ + "img/stock4.6593db0c.png";